import { render, staticRenderFns } from "./suppliers.vue?vue&type=template&id=3b403c1f&scoped=true"
import script from "./suppliers.vue?vue&type=script&lang=js"
export * from "./suppliers.vue?vue&type=script&lang=js"
import style0 from "./suppliers.vue?vue&type=style&index=0&id=3b403c1f&prod&lang=css"
import style1 from "./suppliers.vue?vue&type=style&index=1&id=3b403c1f&prod&lang=css"
import style2 from "./suppliers.vue?vue&type=style&index=2&id=3b403c1f&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3b403c1f",
  null
  
)

export default component.exports